import React, {useState} from 'react';
import visaCard from "../../images/cards/visa.svg";
import masterCard from "../../images/cards/mastercard.svg";
import amex from "../../images/cards/amex.svg";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import configVars from "../../config";
import AddNewCard from './AddNewCard';
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";

const allCards = {
    visa: {
        'name': 'Visa',
        'logo': visaCard
    },
    mastercard: {
        'name': 'Mastercard',
        'logo': masterCard
    },
    amex: {
        'name': 'American Express',
        'logo': amex
    }
};

const UserCards = (props) => {

    const [loading, setLoading] = useState(false);
    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const [translation] = useTranslation("translations");

    const handleDeleteCard = async ( cardID ) => {

        if ( ! cardID ) return;

        setLoading(true);

        let userRequestData = new FormData();
            userRequestData.append( 'payment_method', cardID );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/deletepaymentmethod/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const userResponse = await response.json();
        
                if ( userResponse ) {
                    
                    //console.log( userResponse );
                    
                    if ( userResponse.success === true ) {
                        window.location.reload(true);
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

        setLoading(false);

    }

    const setDefaultPaymentMethod = async (paymentMethod, subID) => {

        if ( ! paymentMethod || ! subID ) return;

        setLoading(true);

        let userRequestData = new FormData();
            userRequestData.append( 'pm_id', paymentMethod );
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'sub_id', subID );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/setsubscriptiondefaultpm/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const userResponse = await response.json();
        
                if ( userResponse ) {
                    
                    //console.log( userResponse );
                    
                    if ( userResponse.success === true ) {
                        window.location.reload(true);
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

        setLoading(false);

    }

    return (
        <div className="row">
            <div className="col-12 col-lg-4 d-flex flex-column justify-content-center">
                <span className="fw-bold">{translation("card_details")}</span>
                <span className="opacity-half font-size-medium d-inline-block w-100 position-relative" style={{top: '-5px'}}>{translation("select_def_pm")}</span>
            </div>

            <div className="col-12 col-lg-8">

                { loading &&
                    <div className="d-flex mb-4">
                        <div className="spinner-border" role="status" >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }

                { props.paymentMethods && props.paymentMethods.map( (paymentMethod, index ) => {
                    return (
                        <div className="d-flex card-item-wrap align-items-center shadow-sm rounded px-3 py-2 my-2 bg-dark-grey cursor-pointer position-relative" key={index}>
                            <div className="pe-3">
                                <img src={allCards[paymentMethod?.card?.brand]?.logo} alt={ paymentMethod?.card?.brand ? paymentMethod?.card?.brand : translation("payment_method")} style={{maxWidth: '45px'}} />
                            </div>
                            <div>
                                <span className="d-inline-block w-100">{allCards[paymentMethod?.card?.brand]?.name} {translation("card_ending_in")} {paymentMethod?.card?.last4}</span>
                                <span className="opacity-half font-size-medium position-relative" style={{top: '-5px'}}>{`${translation("expiring_on")} ${paymentMethod?.card?.exp_month}/${paymentMethod?.card?.exp_year}`}</span>
                            </div>

                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    <Tooltip id={`tooltip-trash-btn-${index}`}>{translation("delete_card")}</Tooltip>
                                }
                                >
                                <button type="button" className="btn btn-link py-0 px-1 text-white bg-secondary position-absolute rounded-0 trash-btn card-action-btn d-none" onClick={() => handleDeleteCard( paymentMethod.id )}>
                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </OverlayTrigger>

                            { paymentMethod.id !== props.defaultPm &&
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id={`tooltip-card-btn-${index}`}>{translation("mark_default")}</Tooltip>
                                    }
                                    >
                                    <button type="button" className="btn btn-link py-0 px-1 text-white bg-secondary position-absolute rounded-0 card-btn card-action-btn d-none" onClick={() => setDefaultPaymentMethod( paymentMethod.id, props?.subID )}>
                                        <i className="fa fa-check-circle-o" aria-hidden="true"></i>
                                    </button>
                                </OverlayTrigger>
                            }

                            <button type="button" className="btn btn-link p-0 text-halite-blue position-absolute default-icon top-0">
                                <i className={`fa fa-${paymentMethod.id === props.defaultPm ? 'circle' : 'circle-o' }`} aria-hidden="true"></i>
                            </button>

                        </div>
                    );
                })}

                { !loading && props.customerID &&
                    <AddNewCard customerID={props.customerID} />
                }

            </div>
        </div>
    )
}

export default UserCards;